import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { ProgressSpinner } from "primereact/progressspinner";

import "./LaudoPdfViewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

class LaudoPdfViewer extends React.Component {
    state = { numPages: null, erro: null };

    componentDidUpdate(prevProps) {
        if (prevProps.file !== this.props.file) {
            this.setState({ numPages: null, erro: null });
        }
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages, erro: null });
    };

    onDocumentLoadError = (erro) => {
        this.setState({ erro });
    };

    render() {
        const { file } = this.props;
        const { numPages, erro } = this.state;

        if (!file) return null;

        if (erro) {
            return <div className="laudo-pdf-viewer-erro">Não foi possível exibir o laudo.</div>;
        }

        return (
            <div className="laudo-pdf-viewer-container">
                <Document
                    file={file}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                    onLoadError={this.onDocumentLoadError}
                    loading={
                        <div className="laudo-pdf-viewer-loading">
                            <ProgressSpinner style={{ width: "100px", height: "100px" }} strokeWidth="4" />
                        </div>
                    }
                >
                    {Array.from(new Array(numPages || 0), (_, index) => (
                        <Page
                            key={`laudo-page-${index + 1}`}
                            pageNumber={index + 1}
                            width={Math.min(window.innerWidth, 900)}
                            renderAnnotationLayer={false}
                            renderTextLayer={false}
                        />
                    ))}
                </Document>
            </div>
        );
    }
}

export default LaudoPdfViewer;
